import * as Yup from "yup";

const Validation = Yup.object({
  name: Yup.string().trim().required("Required*"),
  email: Yup.string().email("Invalid email format").required("Required*"),
  countryCode: Yup.string()
    .matches(/^\+\d{1,4}$/, "Invalid country code")
    .required("Required*"),
  mobileNumber: Yup.string()
    .matches(/^[0-9]{6,15}$/, "Invalid mobile number")
    .required("Required*"),
});

export default Validation;